import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { ActivatedRoute, Router } from '@angular/router';
import { RegistrationAdminService } from '../../shared/services/registration-admin.service';
import { Languages, Service, FormMode, ServiceStatus } from 'src/app/shared/models/enums.model';
import { RegistrationAdminDto } from '../../shared/models/registration-admin.model';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';
import { User } from 'src/app/front-user/shared/models/user.model';
import { BaseRequestService } from 'src/app/front-user/shipyard-service/services/base-request.service';
import { BaseRequest } from 'src/app/shared/models/base-request.model';

@Component({
  selector: 'app-confim-payment',
  templateUrl: './confim-payment.component.html',
  styleUrls: ['./confim-payment.component.css']
})
export class ConfimPaymentComponent implements OnInit {
  public FormMode: any = FormMode;
  public formMode: any = FormMode.Add;
  user: User = new User();
  registerTreasuryOfficerForm: FormGroup;
  displayedLang: string;
  baseRequestId: string = '';
  submitted = false;
  loading = false;
  isErrorMessage: boolean = false;

  isReadOnly = true;
  adminDecisionObject: RegistrationAdminDto = new RegistrationAdminDto();

  showRequest = false;
  baseRequestDTO: BaseRequest;
  lockTaskErrorMessage: boolean = false;

  constructor(private formBuilder: FormBuilder,
    private globalSrv: GlobalServices, private alertService: AlertService,
    private route: ActivatedRoute, private adminSrv: RegistrationAdminService, private router: Router,
    private translate: TranslateService,
    private authenticationService: AuthenticationService,
    private baseRequestService: BaseRequestService, ) {
    this.displayedLang = this.globalSrv.getLanguage() == Languages.Arabic ? 'NameAR' : 'NameEN';
    //this.baseRequestId = this.route.snapshot.params.Id;
    if (history.state.data && history.state.data.requestId) {
      this.baseRequestId = history.state.data.requestId;
      this.getBaseRequest();
    }else{
      window.history.back();
    }
    this.user = this.authenticationService.currentUserValue;

  }

  ngOnInit() {
    this.buildForm();
  }

  buildForm() {
    this.registerTreasuryOfficerForm = this.formBuilder.group({
      IsPaymentConfirmed: ['', [Validators.requiredTrue]],
    });

  }
  getBaseRequest() {
    this.baseRequestService.getByRequestorId(this.baseRequestId, Service.AgentRegisteration).subscribe(
      d => {
        this.baseRequestDTO = d.Data;
        //   if (this.baseRequestDTO.StatusId == ServiceStatus.PendingOnTreasuryOfficerConfirmation) {
        //     this.formMode = FormMode.Add;
        //     this.registerTreasuryOfficerForm.enable();
        //   }
        //  else 
        if (history.state.data && history.state.data.isCompleted) {
          this.registerTreasuryOfficerForm.patchValue({
            IsPaymentConfirmed: true,

          });
          this.formMode = FormMode.Readonly;
          this.registerTreasuryOfficerForm.disable();
        }
        // else{
        //   this.registerTreasuryOfficerForm.patchValue({
        //     IsPaymentConfirmed: true,

        //   });
        //   this.formMode = FormMode.Readonly;
        //   this.registerTreasuryOfficerForm.disable();
        // }
      }
    )
  }

  get f() {
    return this.registerTreasuryOfficerForm.controls;
  }


  onSubmit(b) {
    this.submitted = true;
    // stop here if form is invalid
    if (this.registerTreasuryOfficerForm.invalid) {
      return;
    }
    this.alertService.clear();
    this.globalSrv.isLoaderEnabled = true;
    this.loading = true;
    this.adminDecisionObject = this.registerTreasuryOfficerForm.value;
    this.adminDecisionObject.AdminEmail = this.user.UserName;
    this.adminDecisionObject.RequestId = this.baseRequestId;


    this.adminSrv.addTreasuryConfirmation(this.adminDecisionObject)
      .subscribe(
        (data: ResponseObject) => {
          if (data.Success) {
            // this.alertService.success(this.translate.instant('FRONT_USER.SUCCESS_MESSAGES.ADD_SUCCESSFULLY'));

            this.globalSrv.isLoaderEnabled = false;
            this.registerTreasuryOfficerForm.reset();
            this.showRequest = true;
            this.isErrorMessage = false;
            this.loading = false;
            // this.router.navigate(['/Tasks']);
          } else if (data.ErrorMessages.find(e => e == "TaskCompletedByAnotherUser") != null) {
            this.globalSrv.isLoaderEnabled = false;
            this.lockTaskErrorMessage = true;
            this.showRequest = true;
          } else {
            this.showRequest = true;
            this.isErrorMessage = true;
            this.globalSrv.isLoaderEnabled = false;
            //this.alertService.error(this.translate.instant('FRONT_USER.ERRORS_MESSAGES.'+data.ErrorMessages[0]));
            this.loading = false;
          }

        });
  }


}
